var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWriteSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.linesandangles_een{fill:#e6edec;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "linesandangles_een",
    d: "M19,11H9V9h10V11z M23,19.414V27H5V5h18v3.586L28.414,14L23,19.414z M23.086,16.5L20.5,13.914 l-4.5,4.5V21h2.586L23.086,16.5z M23,11.414L21.914,12.5l2.586,2.586L25.586,14L23,11.414z M21,21.414L19.414,23H9v-2h5v-2H9v-2 h5.586l2-2H9v-2h9.586L21,10.586V7H7v18h14V21.414z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteSvgrepoCom1);
export default __webpack_public_path__ + "static/media/write-svgrepo-com (1).46f837dca32b0bd984c3cfad63a8d495.svg";
export { ForwardRef as ReactComponent };